import { createFileRoute } from "@tanstack/react-router";
import { BoardPage } from "../features/board/BoardPage";

// ?board=<id> opens that board: how a thread's Workbench is opened in full.
// ?fromFile=<file>&c=<Tread> opens a sent file as a live preview (TANK's "Open in Blueprint").
export const Route = createFileRoute("/w/$ws/boards")({
  component: () => {
    const { board, fromFile, c } = Route.useSearch();
    return (
      <BoardPage
        openBoardId={board}
        fromFile={fromFile && c ? { fileId: fromFile, channelId: c } : undefined}
      />
    );
  },
  validateSearch: (s: Record<string, unknown>): { board?: string; fromFile?: string; c?: string } => ({
    board: typeof s.board === "string" ? s.board : undefined,
    fromFile:
      typeof s.fromFile === "string" && /^[A-Za-z0-9_-]{1,40}$/.test(s.fromFile) ? s.fromFile : undefined,
    c: typeof s.c === "string" && /^[A-Za-z0-9_-]{1,40}$/.test(s.c) ? s.c : undefined,
  }),
});
